import React, { useState } from "react";
import Elements from "./Elements";
import "./Schedule.css";
import schedule from "../json/schedule.json";


const Schedule = () => {

    const insertStr = (str) => {
        return (
            str.slice(0, 4) +
            "年" +
            str.slice(4, 6) +
            "月" +
            str.slice(6, 8) +
            "日"
        );
    }


    return (
        <div className="schedule-wrapper">
            <div className="schedule-title">
                <span className="schedule-title-text">
                    Schedule
                </span>
            </div>
            <section className="schedule-section-wrapper">
                {schedule.map((item, index) => {
                    return (
                        <div key={index}>
                            <Elements
                                key={index}
                                id={item.date}
                                date={insertStr(item.date)}
                                imagePath={item.imagePath}
                                location={item.location}
                                address={item.address}
                                title={item.title}
                                artist={item.artist}
                                contents={item.contents}
                                open={item.open}
                                start={item.start}
                                door={item.door}
                                adv={item.adv}
                                drink={item.drink}
                                etc={item.etc}
                            />
                        </div>
                    );
                })}



            </section>
        </div>

    );
}
export default Schedule;